module.exports = __webpack_public_path__ + "static/media/rackham02full.517b751b.jpg";